// Ảnh GIF 1x1 trong suốt — dùng khi thiếu file icon để không vỡ layout.
export const FALLBACK_IMG =
    'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

/**
 * Chạy một require() ảnh trong try/catch.
 *
 * Với các đường dẫn động lấy từ dữ liệu server (vd tên ngân hàng, mã nhà cung cấp),
 * nếu file icon không tồn tại thì require() sẽ NÉM lỗi ngay lúc render. Do app không
 * có Error Boundary, một lỗi như vậy làm trắng màn hình toàn bộ. Hàm này bắt lỗi và
 * trả về ảnh trong suốt để component vẫn render bình thường.
 *
 * Lưu ý: phải viết require(`...`) ngay TẠI chỗ gọi (trong hàm loader truyền vào) để
 * webpack còn dựng được require.context cho cả thư mục ảnh.
 */
export const tryImg = (loader: () => unknown): string => {
    try {
        return (loader() as string) || FALLBACK_IMG;
    } catch {
        return FALLBACK_IMG;
    }
};
